import Operation from './Operation';

export default class Modulus extends Operation {
  cal (a, b) {
    return a % b;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Modulus.js